// context/TimerContext.tsx
import { createContext, useContext, useEffect, useState } from "react";

const TimerContext = createContext<Date>(new Date());

export const useTimer = () => useContext(TimerContext);

export function TimerProvider({ children }: { children: React.ReactNode }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60000); // match your polling rate
    return () => clearInterval(interval);
  }, []);

  return (
    <TimerContext.Provider value={now}>
      {children}
    </TimerContext.Provider>
  );
}
